require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./apis-and-microservices-basic-node-and-express-chain-middleware-to-create-a-time-server.json") })
        }
      }, "path---apis-and-microservices-basic-node-and-express-chain-middleware-to-create-a-time-server");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---apis-and-microservices-basic-node-and-express-chain-middleware-to-create-a-time-server!./.cache/json/apis-and-microservices-basic-node-and-express-chain-middleware-to-create-a-time-server.json
// module id = 1253
// module chunks = 231608221292675